<div class="full-column">
	<app-hub-nav-header
		[sportCode]="league"
		currentRoute="best-odds"
	></app-hub-nav-header>

	<!-- <div class="best-odds-title">
		<h1 class="title">
			{{ sportMeta && sportMeta.page_title
				? sportMeta.page_title
				: '' }}
        </h1>
	</div> -->

	<!-- <div class="best-odds-title">
		<span class="title" *ngIf="sportMeta || pageMeta">
			
			<img *ngIf="sportMeta || pageMeta"
				class="icon"
				[src]="
					sportMeta && sportMeta.icon_thumbnail && sportMeta.icon_thumbnail.dynamic_url
					? sportMeta.icon_thumbnail.dynamic_url
					: pageMeta.icon_thumbnail.dynamic_url
				"
			/>
			{{
				sportMeta && sportMeta.page_title
				? sportMeta.page_title
				: pageMeta.app_page_header
			}}
		</span>
	</div> -->
	<div class="page-description" >
		<h1 class="page-title">			
			{{ sportMeta && sportMeta.page_title
				 ? sportMeta.page_title
				 : '' }} 
		</h1>
		<div class="description">
			<span *ngIf="sportMeta && sportMeta.app_page_subheader" [innerHTML]="trustedDescription">
			</span>
			<span *ngIf="!sportMeta || !sportMeta.app_page_subheader">
				{{ environment.siteTitle }} presents bettors with the best bets on offer. Covering all the big sports and legal betting states in the USA,
				we <a [routerLink]='environment.optionalFeatures.includes("best-books") ? "/betting" : null'>compare the sportsbooks</a>' odds and lines so you can maximize your returns.
			</span>
		</div>
	</div>

	<div
		class="metabet-odds-board mob-side-margin metabet-league-{{ renameLeague(league) }}
			metabet-location-{{ isValidState(userState) ? (userState | lowercase) : 'nj' }}"
	></div>
	<app-best-offers [sportCode]="league" *ngIf="environment.optionalFeatures.includes('best-offers')"></app-best-offers>
    <div *ngIf="trustedCopy" [innerHTML]="trustedCopy"></div>
</div>
<app-adhesive-banner *ngIf="environment.optionalFeatures.includes('adhesive-banner')"></app-adhesive-banner>
